/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    name: 'dashboard',
    // redirect: { name: 'Shedule' },
    component: () => import(/* webpackChunkName: "dashboard"  */ '@/views/dashboard/index.vue'),
    meta: {
      id: '1',
      title: 'Дашборд | Сводка',
      visible: true,
      clickable: true,
      // icon: 'el-icon-menu',
      icon: ['fas', 'chart-area'],
      layout: 'main-layout'
    },
    children: []
  },
  {
    path: '/tenantsIncome',
    name: 'tenantsIncome',
    component: () => import(/* webpackChunkName: "tenantsIncome"  */ '@/views/tenantsIncome/index'),
    meta: {
      id: '2',
      title: 'Выплаты|Расчет',
      custom_icon: 'coins.svg',
      layout: 'main-layout'
    },
    children: []
  },
  {
    path: '/shedule',
    name: 'schedule',
    component: () => import(/* webpackChunkName: "shedule"  */ '@/views/shedule/index'),
    meta: {
      id: '3',
      title: 'Аренды',
      icon: ['fas', 'calendar-alt'],
      layout: 'main-layout'
    },
    children: []
  },
  {
    path: '/sheduleV2',
    name: 'ScheduleV2',
    component: () => import(/* webpackChunkName: "shedule"  */ '@/modules/schedule/views/SchedulePage.vue'),
    meta: {
      id: '23',
      title: 'Аренды V2',
      icon: ['fas', 'calendar-alt'],
      layout: 'main-layout'
    },
    children: []
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout'),
    name: 'Reports',
    meta: {
      id: '4',
      title: 'Арендаторы',
      icon: ['fas', 'chart-pie'],
      layout: 'main-layout'
    },
    children: [
      {
        // path: '',
        path: '/report/consolidated',
        component: () => import(/* webpackChunkName: "consolidatedReport"  */ '@/views/consolidatedReport/index'),
        name: 'ReportConsolidated',
        meta: {
          id: '41',
          title: 'Ежемесячный отчет',
          icon: ['fas', 'chart-pie'],
          layout: 'main-layout'
        },
        children: []
      },
      {
        path: '/report/techInspectionReport',
        component: () => import(/* webpackChunkName: "techInspectionReport"  */ '@/views/techInspectionReport/index'),
        name: 'ReportTechInspectionReport',
        meta: {
          id: 42,
          title: 'Ежемесячный отчет по Т.О.',
          icon: ['fas', 'chart-pie'],
          layout: 'main-layout'
        },
        children: []
      },
      {
        path: '/report/carReport',
        component: () => import(/* webpackChunkName: "CarReportView"  */ '@/modules/reports/views/CarReportView'),
        name: 'CarReport',
        meta: {
          id: 43,
          title: 'Отчет по автопарку',
          icon: ['fas', 'chart-pie'],
          layout: 'main-layout'
        },
        children: []
      }
    ]
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout'),
    name: 'Tenants',
    meta: {
      id: '5',
      title: 'Арендаторы',
      custom_icon: 'users.svg',
      layout: 'main-layout'
    },
    children: [
      {
        path: '/tenantsInfo',
        name: 'TenantsInfo',
        component: () => import(/* webpackChunkName: "tenantsInfo"  */ '@/modules/tenantsInfo/views/TenantsPage.vue'),
        meta: {
          id: '51',
          title: 'Арендаторы',
          icon: ['fas', 'user-check'],
          layout: 'main-layout'
        }
      },
      {
        path: '/tenantsInfoV2',
        name: 'TenantsInfoV2',
        component: () => import(/* webpackChunkName: "tenantsInfo"  */ '@/modules/tenantsInfo/views/TenantsPage.vue'),
        meta: {
          id: '54',
          title: 'Арендаторы V2',
          icon: ['fas', 'user-check'],
          layout: 'main-layout',
          inDeveloping: true
        }
      },
      {
        path: '/debtors_by_balances',
        name: 'TenantsInfo.debtors_by_balances',
        component: () => import(/* webpackChunkName: "tenantsInfo"  */ '@/views/tenantsInfo/debtorsByBalances'),
        meta: {
          id: '234',
          title: 'Реестр должников по балансам',
          icon: ['fas', 'user-check'],
          layout: 'main-layout'
        }
      },
      {
        path: '/driver_deposit_debts',
        name: 'TenantsInfo.driver_deposit_debts',
        component: () => import(/* webpackChunkName: "tenantsInfo"  */ '@/views/tenantsInfo/debtorsByDebts'),
        meta: {
          id: '2314',
          title: 'Реестр по депозитам',
          icon: ['fas', 'user-check'],
          layout: 'main-layout'
        }
      },
      {
        name: 'TenantsCandidatesInfo',
        path: '/tenantsCandidatesInfo',
        component: () => import(/* webpackChunkName: "tenantsCandidatesInfo"  */ '@/views/tenantsCandidatesInfo/index'),
        meta: {
          id: '52',
          title: 'Резерв',
          icon: ['fas', 'user-clock'],
          layout: 'main-layout'
        }
      },
      {
        name: 'DriverSurcharge',
        path: '/driverSurcharge',
        component: () => import('@/modules/registry/views/RegistryOfSurchargesView.vue'),
        meta: {
          id: '148',
          title: 'Реестр по доплатам',
          icon: ['fas', 'user-clock'],
          layout: 'main-layout'
        }
      },
      {
        name: 'DriverGiveOutAmount',
        path: '/driverGiveOutAmount',
        component: () => import('@/modules/registry/views/RegistryOfGiveOutAmountView.vue'),
        meta: {
          id: '1488',
          title: 'Реестр по расчетам',
          icon: ['fas', 'user-clock'],
          layout: 'main-layout'
        }
      },
      {
        name: 'RegistryWithdraw',
        path: '/registryWithdraw',
        component: () => import('@/modules/registry/views/RegistryOfWithdrawView.vue'),
        meta: {
          id: '1489',
          title: 'Реестр по выплатам',
          icon: ['fas', 'user-clock'],
          layout: 'main-layout'
        }
      },
      {
        name: 'CashRegister',
        path: '/cashRegister',
        component: () => import('@/modules/registry/views/RegistryOfReadyCashView.vue'),
        meta: {
          id: '1449',
          title: 'Реестр по наличным',
          icon: ['fas', 'user-clock'],
          layout: 'main-layout'
        }
      },
      // {
      //   name: 'OpenTransactions',
      //   path: '/OpenTransactions',
      //   component: () => import(/* webpackChunkName: "tenantsCandidatesInfo"  */ '@/views/OpenTransactions/index'),
      //   meta: {
      //     id: '70',
      //     title: 'Реестр должников',
      //     icon: ['fas', 'list'],
      //     layout: 'main-layout'
      //   }
      // },
      {
        name: 'OpenTransactionsDebts',
        path: '/OpenTransactionsDebts',
        component: () => import(/* webpackChunkName: "teДепозит на nantsCandidatesInfo"  */ '@/views/OpenTransactionsDebts/index'),
        meta: {
          id: '72340',
          title: 'Реестр должников',
          icon: ['fas', 'list'],
          layout: 'main-layout'
        }
      }
    ]
  },
  {
    path: '/carpark',
    name: 'CarPark',
    component: () => import(/* webpackChunkName: "carLocalParks"  */ '@/modules/carParks/views/CarParkPage.vue'),
    meta: {
      id: '6',
      title: 'Автопарк',
      icon: ['fas', 'taxi'],
      layout: 'main-layout'
    },
    children: []
  },
  {
    path: '/localCarPark',
    name: 'localCarPark',
    component: () => import(/* webpackChunkName: "carLocalParks"  */ '@/views/carLocalParks/index'),
    meta: {
      id: '6123',
      title: 'Парки',
      custom_icon: 'user_mic.svg',
      layout: 'main-layout'
    },
    children: []
  },
  {
    path: '/localCarParkV2',
    name: 'LocalCarParkV2',
    component: () => import(/* webpackChunkName: "carLocalParks"  */ '@/modules/localParks/views/LocalParksPage.vue'),
    meta: {
      id: '66',
      title: 'Парки V2',
      custom_icon: 'user_mic.svg',
      layout: 'main-layout',
      inDeveloping: true
    },
    children: []
  },
  {
    path: '',
    name: 'contracts.redirect',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout'),
    meta: {
      id: '81234',
      title: 'Договоры',
      custom_icon: 'document.svg',
      layout: 'main-layout'
    },
    children: [
      {
        path: '/contracts',
        name: 'Contracts',
        component: () => import(/* webpackChunkName: "contracts"  */ '@/views/contracts'),
        meta: {
          id: '7',
          title: 'Договоры',
          custom_icon: 'document.svg',
          layout: 'main-layout'
        },
        children: []
      },
      {
        path: '/contracts/v2',
        name: 'ContractsV2',
        component: () => import(/* webpackChunkName: "contracts"  */ '@/modules/contracts/views/ContractsView.vue'),
        meta: {
          id: '71234',
          title: 'Договоры V2',
          custom_icon: 'document.svg',
          layout: 'main-layout',
          inDeveloping: true
        },
        children: [],
      },
    ]
  },
  {
    path: '',
    name: 'investors.redirect',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout'),

    meta: {
      id: '8',
      title: 'Собственники авто ',
      custom_icon: 'user.svg',
      layout: 'main-layout'
    },
    children: [
      {
        path: '/investors',
        name: 'Investors',
        component: () => import(/* webpackChunkName: "investors"  */ '@/views/investors'),
        meta: {
          id: '81',
          title: 'Собственники авто',
          custom_icon: 'user.svg',
          layout: 'main-layout'
        },
      },
      {
        path: '/investors/v2',
        name: 'Investors.v2',
        component: () => import(/* webpackChunkName: "investors"  */ '@/modules/investors/views/InvestorsView.vue'),
        meta: {
          id: '82',
          title: 'Собственники авто V2',
          custom_icon: 'user.svg',
          layout: 'main-layout',
          inDeveloping: true
        },
      },
    ]
  },
  {
    path: '/techInspection',
    component: () => import(/* webpackChunkName: "techInspection"  */ '@/views/techInspection/index'),
    redirect: { name: 'techInspection.requests' },
    name: 'techInspection.redirect',
    meta: {
      id: '91',
      title: 'Т.О',
      custom_icon: 'car_repair.svg',
      layout: 'mainLayout'
    },
    children: [
      {
        path: '',
        name: 'techInspection.requests',
        meta: {
          id: '393',
          title: 'Т.О Заявки',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/techInspection/ServiceRequests')
      },
      {
        path: 'repairs',
        name: 'techInspection.repairs',
        meta: {
          id: '94',
          title: 'Т.О Ремонты',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "CurrentRepairs"  */ '@/views/techInspection/CurrentRepairs')
      },
      {
        path: 'history',
        name: 'techInspection.history',
        meta: {
          id: '95',
          title: 'Т.О История',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "History"  */ '@/views/techInspection/History')
      }
    ]
  },
  {
    path: '/parts',
    name: 'Parts',
    redirect: { name: 'parts.storage-table' },
    component: () => import(/* webpackChunkName: "parts"  */ '@/views/parts/index'),
    meta: {
      id: '92',
      title: 'Склад',
      custom_icon: 'warehouse.svg',
      layout: 'mainLayout',
      allowedRouts: ['parts.providers-table', 'parts.categories-table', 'parts.parts-table', 'parts.storage-table']
    },
    children: [
      {
        path: 'transfer-history-list',
        name: 'parts.transfer-history-list',
        meta: {
          id: '92223',
          title: 'Склад | История перемещений',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/TransferHistoryList.vue')
      },
      {
        path: 'orders',
        name: 'parts.orders-table',
        meta: {
          id: '93',
          title: 'Склад | Заказы',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/parts/ordersTable')
      },
      {
        path: 'providers',
        name: 'parts.providers-table',
        meta: {
          id: '100',
          title: 'Склад | Поставщики',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/PartProvidersTable.vue')
      },
      {
        path: 'storage',
        name: 'parts.storage-table',
        meta: {
          id: '101',
          title: 'Склад | Склад',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/parts/StorageTable')
      },
      {
        path: 'categories',
        name: 'parts.categories-table',
        meta: {
          id: '102',
          title: 'Склад | Категории',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/PartsCategoriesTable')
      },
      {
        path: 'parts',
        name: 'parts.parts-table',
        meta: {
          id: '103',
          title: 'Склад | Запчасти',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/PartsTable.vue')
      },
      {
        path: 'items',
        name: 'parts.items-table',
        meta: {
          id: '103',
          title: 'Склад | Позиции',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/ItemsTable.vue')
      },
      {
        path: 'transfers-requests',
        name: 'parts.transfer-requests',
        meta: {
          id: '12323',
          title: 'Склад | Заявки на пеермещение',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/TransfersRequestsTable.vue')
      },
      {
        path: 'transfers-requests/:id',
        name: 'parts.transfer-requests.id',
        meta: {
          id: '1232233',
          title: 'Склад | Пеермещение позиции по складам',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/TransfersRequestsTableById.vue')
      },
      {
        path: 'decommission',
        name: 'parts.decommission',
        meta: {
          title: 'Склад | Списания',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/parts/decommission')
      },
      {
        path: 'decommission/act/:id',
        name: 'parts.decommission.act',
        meta: {
          title: 'Склад | Акт списания детализированный',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/decommission/actTable.vue')
      },
      {
        path: 'decommission/movement/history',
        name: 'parts.decommission.movement.history',
        meta: {
          title: 'Склад | Движение по складу',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/decommission/movementHistory.vue')
      },
      {
        path: 'decommission/movement/history/details/:id',
        name: 'parts.decommission.movement.history.details',
        meta: {
          title: 'Склад | Детализированное движение по складу',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/decommission/movementHistoryDetails.vue')
      }

      // {
      //   path: 'decommission',
      //   meta: {
      //     id: '96',
      //     icon: ['fas', 'user-cog'],
      //     layout: 'mainLayout'
      //   },
      //   redirect: { name: 'parts.decommission' },
      //   component: () => import(/* webpackChunkName: "partsDecommission"  */ '@/views/parts/decommission.vue'),
      //   children: [
      //     {
      //       path: '/',
      //       name: 'parts.decommission',
      //       meta: {
      //         title: 'Запчасти | Списания',
      //         icon: ['fas', 'user-cog'],
      //         layout: 'mainLayout'
      //       },
      //       component: () => import(/* webpackChunkName: "partsDecommissionTable"  */ '@/components/parts/decommission/table.vue')
      //     },
      //     {
      //       path: 'act',
      //       name: 'parts.decommission.act',
      //       meta: {
      //         title: 'Запчасти | Акт списания',
      //         icon: ['fas', 'user-cog'],
      //         layout: 'mainLayout'
      //       },
      //       component: () => import(/* webpackChunkName: "actTable"  */ '@/components/parts/decommission/actTable.vue')
      //     }
      //   ]
      // }
    ]
  },
  {
    path: '/fines',
    name: 'fines.layout',
    // redirect: { name: 'parts.storage-table' },
    // component: () => import(/* webpackChunkName: "parts"  */ '@/views/fines/layout'),
    component: () => import(/* webpackChunkName: "parts"  */ '@/modules/fines/views/FinesLayout.vue'),
    meta: {
      id: '109',
      title: 'Штрафы',
      custom_icon: 'cvtv.svg',
      layout: 'mainLayout'
    },
    children: [
      // {
      //   path: '',
      //   name: 'fines',
      //   meta: {
      //     id: '93',
      //     title: 'Штрафы',
      //     icon: ['fas', 'user-cog'],
      //     layout: 'mainLayout'
      //   },
      //   component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/fines/index')
      // },
      // {
      //   path: '/fines/history',
      //   name: 'fines.history',
      //   meta: {
      //     id: '199',
      //     title: 'Штрафы | История',
      //     icon: ['fas', 'user-cog'],
      //     layout: 'mainLayout'
      //   },
      //   component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/fines/history.vue')
      // },
      {
        path: '/fines',
        name: 'fines',
        meta: {
          id: '9332',
          title: 'Штрафы',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/modules/fines/views/FinesView.vue')
      },
      {
        path: '/fines/history',
        name: 'fines.history',
        meta: {
          id: '1993',
          title: 'Штрафы | История',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/modules/fines/views/FinesHistoryView.vue')
      },
      {
        path: '/fines/archive',
        name: 'fines.archive',
        meta: {
          id: '19933',
          title: 'Штрафы | Удаленные',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/modules/fines/views/FinesArchive.vue')
      }
    ]
  },
  {
    path: '/templates/',
    name: 'templates.layout',
    // redirect: { name: 'parts.storage-table' },
    component: () => import(/* webpackChunkName: "parts"  */ '@/views/templates/layout'),
    meta: {
      id: '122',
      title: 'ЭДО',
      visible: false,
      custom_icon: 'cvtv.svg',
      layout: 'mainLayout'
    },
    children: [
      {
        path: ':park_id',
        name: 'templates',
        meta: {
          id: '123',
          title: 'ЭДО | Шаблоны',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/templates/index')
      },
      {
        path: '/templates/:park_id/types',
        name: 'templates.types',
        meta: {
          id: '124',
          title: 'ЭДО | Типы',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/templates/types')
      },
      {
        path: '/templates/:park_id/editor',
        name: 'templates.editor',
        meta: {
          id: '129',
          title: 'ЭДО | Документ',
          icon: ['fas', 'user-cog'],
          layout: 'mainLayout'
        },
        component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/templates/editor')
      }
    ]
  },
  {
    path: '/offer',
    name: 'templates.offer',
    meta: {
      id: '1234323444',
      title: 'ЭДО | Оферта',
      icon: ['fas', 'user-cog'],
      layout: 'mainLayout'
    },
    children: [],
    component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/modules/edmTemplates/views/EdmOfferView.vue')
    // component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/templates/offer')
  },
  {
    path: '/configurator/:settings_id',
    name: 'Configurator',
    component: () => import(/* webpackChunkName: "configurator"  */ '@/views/configurator/index'),
    meta: {
      id: '345',
      visible: false,
      title: 'Конфигуратор',
      icon: ['fas', 'sliders-h'],
      layout: 'main-layout'
    }
  },
  {
    path: '/promo',
    component: () => import(/* webpackChunkName: "promoPage"  */ '@/modules/promo/views/PromoPage.vue'),
    name: 'promo',
    meta: {
      id: '10',
      title: 'Промо акции',
      icon: ['fas', 'tag'],
      layout: 'main-layout'
    },
    children: []
  },
  {
    path: '/promo/:id',
    component: () => import(/* webpackChunkName: "promoStatsPage"  */ '@/modules/promo/views/PromoStats.vue'),
    name: 'promo.stats',
    meta: {
      id: '1001',
      title: 'Статистика',
      visible: false,
      layout: 'main-layout'
    },
    children: []
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout'),
    name: 'settings.crm',
    meta: {
      title: 'Параметры',
      icon: ['fas', 'sliders-h'],
      layout: 'main-layout',
      id: '11',
      marginTop: true
    },
    children: [
      {
        path: '/drivers-app-settings',
        name: 'DriversAppSettings',
        component: () => import(/* webpackChunkName: "driversAppSettings"  */ '@/modules/driversAppSettings/views/DriversAppSettingsView.vue'),
        meta: {
          id: '105',
          title: 'Приложение водителей',
          icon: ['fas', 'mobile'],
          layout: 'main-layout'
        }
      },
      {
        path: '/work-rules-settings',
        name: 'WorkRulesSettings',
        component: () => import(/* webpackChunkName: "workRulesSettings"  */ '@/modules/workRules/views/WorkRulesView.vue'),
        meta: {
          id: '106',
          title: 'Условия работы',
          icon: ['fas', 'mobile'],
          layout: 'main-layout'
        }
      },
      {
        path: '/admins',
        name: 'Admins',
        component: () => import(/* webpackChunkName: "admins"  */ '@/views/admins/index'),
        meta: {
          id: '101',
          title: 'Администраторы',
          icon: ['fas', 'user-shield'],
          layout: 'main-layout'
        }
      },
      {
        path: '/logs',
        name: 'Logs',
        component: () => import(/* webpackChunkName: "logs"  */ '@/modules/logs/views/LogsView.vue'),
        // component: () => import(/* webpackChunkName: "logs"  */ '@/views/admins/logs'),
        meta: {
          id: '1011233',
          title: 'Лог Действий',
          icon: ['fas', 'user-shield'],
          layout: 'main-layout'
        }
      },
      {
        path: '/roles',
        name: 'Roles',
        component: () => import(/* webpackChunkName: "roles"  */ '@/views/roles/index'),
        meta: {
          id: '102',
          title: 'Роли',
          icon: ['fas', 'user-tag'],
          layout: 'main-layout'
        }
      },
      {
        path: '/crm',
        name: 'CRM',
        component: () => import(/* webpackChunkName: "crm"  */ '@/views/crm/index'),
        meta: {
          id: '103',
          title: 'Настройки CRM',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout'
        }
      },
      {
        path: '/edm',
        name: 'EDMSettings',
        component: () => import(/* webpackChunkName: "crm"  */ '@/modules/edmSettings/views/EdmSettingsView.vue'),
        meta: {
          id: '1334',
          title: 'Настройки ЭДО',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout'
        }
      },
      {
        path: '/edm/fine-payment-template-editor',
        name: 'finePaymentTemplateEditor',
        component: () => import(/* webpackChunkName: "crm"  */ '@/modules/edmSettings/views/FinePaymentTemplateView.vue'),
        meta: {
          id: '1335',
          title: 'Шаблон платежного документа',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          visible: false
        }
      },
      {
        path: '/edm/fine-payment-wrapper-template-editor',
        name: 'finePaymentWrapperTemplateEditor',
        component: () => import(/* webpackChunkName: "crm"  */ '@/modules/edmSettings/views/FinePaymentWrapperTemplateView.vue'),
        meta: {
          id: '1336',
          title: 'Обертка платежного документа',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          visible: false
        }
      },
      {
        path: '/techInspection/settings',
        name: 'TechInspectionSettings',
        component: () => import(/* webpackChunkName: "crm"  */ '@/modules/techInspectionSettings/views/MaintenanceSettingsPage.vue'),
        meta: {
          id: '1333',
          title: 'Настройки ТО',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout'
        }
      },
      {
        path: '/crm/keys',
        name: 'CRM.keys',
        component: () => import(/* webpackChunkName: "crm"  */ '@/modules/crmKeysSettings/views/CrmKeysSettingsView.vue'),
        meta: {
          id: '143',
          title: 'Ключи CRM',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout'
        }
      }
    ]
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */'@/views/login'),
    meta: {
      title: 'Авторизация',
      layout: 'empty-layout',
      visible: false
    },
    children: []
  },
  {
    path: '/registration',
    name: 'Registration',
    component: () => import(/* webpackChunkName: "registration" */'@/views/registration'),
    meta: {
      layout: 'empty-layout',
      visible: false
    },
    children: []
  }

]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
